/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IUsercentricsProps } from './usercentrics.props.autogenerated';

export interface IUsercentricsViewProps extends IUsercentricsProps<{}> {}

/**
 *
 * Usercentrics component
 * @extends {React.PureComponent<IUsercentricsProps<{}>>}
 */
class Usercentrics extends React.PureComponent<IUsercentricsProps<{}>> {
    public render(): JSX.Element | null {
        return (
            <>
                <script
                    id='usercentrics-cmp'
                    src='https://app.usercentrics.eu/browser-ui/latest/loader.js'
                    data-settings-id={this.props.config.dataSettingsId}
                    async={!!this.props.config.async}
                ></script>
            </>
        );
    }
}

export default Usercentrics;
